<template>
    <default-sidebar :active="$store.state.sidebars.showReceiptsCreateForm">
        <receipts-create-form v-if="$store.state.sidebars.showReceiptsCreateForm"/>
    </default-sidebar>
</template>

<script>
    import DefaultSidebar from "./DefaultSidebar";
    import ReceiptsCreateForm from "../forms/ReceiptsCreateForm";

    export default {
        name: "ReceiptsCreateFormSidebar",
        components: {
            DefaultSidebar,
            ReceiptsCreateForm,
        },
    }
</script>

<style scoped lang="scss">

</style>
